(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-featured-ams"] && !Shopify.designMode) return;
  try {
    
  $('.as-feature-inner-mob, .as-feature-inner').slick({
    speed: 6000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    draggable:false,
    focusOnSelect:false,
    pauseOnFocus:false,
    pauseOnHover:false,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diwali-sale"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STORE_KEY = 'gb_bundle_v1';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init(root) {
    if (!root || root.__gbInit) return;
    root.__gbInit = true;

    var d = root.dataset;
    var cfg = {
    giftValue: 76900,
      threshold: (parseFloat(d.threshold) || 2499) * 100,
      root: d.root || '/',
      clearCart: d.clearCart !== 'false',
      moneyFormat: d.moneyFormat || '\u20B9{' + '{amount_no_decimals}}',
      headingLocked: d.headingLocked || 'Add [amount] more to unlock a FREE gift',
      headingProgress: d.headingProgress || 'You\u2019re [amount] away from a FREE Gut Cleanse',
      headingUnlocked: d.headingUnlocked || 'Free gift unlocked!',
      addLabel: d.addLabel || 'Add to cart',
      popupTitle: d.popupTitle || 'Your bundle',
      emptyText: d.emptyText || 'Nothing added yet.'
    };
    var free = d.freeVid ? {
      vid: Number(d.freeVid),
      title: d.freeTitle || 'Free gift',
      price: Number(d.freePrice) || 0,
      compare: Number(d.freeCompare) || 0,
      image: d.freeImage || ''
    } : null;

    // offer variant -> freebie variant (theme settings: offer_variant / freebie_variant, same order)
    function toList(str) {
      return (str || '').split(/\r?\n|,/).map(function (v) { return v.trim(); }).filter(Boolean);
    }
    var freebieMap = {};
    (function () {
      var offers = toList(d.offerIds);
      var freebies = toList(d.freebieIds);
      offers.forEach(function (id, i) {
        if (freebies[i]) freebieMap[id] = freebies[i];
      });
    })();

    var boxesEl = root.querySelector('[data-boxes]');
    var headingEl = root.querySelector('[data-heading]');
    var modal = root.querySelector('[data-modal]');
    var modalList = root.querySelector('[data-modal-list]');
    var modalTitle = root.querySelector('[data-modal-title]');
    var gridEl = root.querySelector('[data-grid]');
    var lastAdded = null;
    var busy = false;
    var prevUnlocked = null;

    // popup ko body me shift karo taaki theme ke parent CSS se width/position na bigde
    var modalId = 'GBModal-' + root.id;
    var oldModal = document.getElementById(modalId);
    if (oldModal && oldModal !== modal) oldModal.remove();
    modal.id = modalId;
    var rcs = getComputedStyle(root);
    ['--gb-accent', '--gb-box-bg', '--gb-bg'].forEach(function (v) {
      modal.style.setProperty(v, rcs.getPropertyValue(v));
    });
    document.body.appendChild(modal);

    function qa(sel) {
      return Array.prototype.slice.call(root.querySelectorAll(sel))
        .concat(Array.prototype.slice.call(modal.querySelectorAll(sel)));
    }

    // checkout buttons ka original label yaad rakho (Please wait ke baad wapas lagane ke liye)
    qa('[data-checkout]').forEach(function (b) { b.dataset.label = b.textContent.replace(/\s+/g, ' ').trim(); });
    function resetCheckoutBtns() {
      qa('[data-checkout]').forEach(function (b) { b.textContent = b.dataset.label || 'Checkout'; });
    }

    /* ---------- money ---------- */
    function group(num, dec, thou, dp) {
      var parts = num.toFixed(dec).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts[1] ? whole + dp + parts[1] : whole;
    }
    function fmt(cents) {
      var n = cents / 100;
      var whole = Math.round(cents) % 100 === 0;
      return cfg.moneyFormat.replace(/<[^>]*>/g, '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) {
        switch (k) {
          case 'amount_no_decimals': return group(n, 0, ',', '.');
          case 'amount_with_comma_separator': return whole ? group(n, 0, '.', ',') : group(n, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return group(n, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return group(n, whole ? 0 : 2, "'", '.');
          case 'amount_no_decimals_with_space_separator': return group(n, 0, ' ', '.');
          case 'amount_with_space_separator': return group(n, whole ? 0 : 2, ' ', ',');
          default: return whole ? group(n, 0, ',', '.') : group(n, 2, ',', '.');
        }
      });
    }

    /* ---------- storage ---------- */
    function load() {
      try {
        var raw = JSON.parse(localStorage.getItem(STORE_KEY) || '[]');
        return Array.isArray(raw) ? raw.filter(function (i) { return i && i.vid && i.qty > 0; }) : [];
      } catch (e) { return []; }
    }
    function save() {
      try { localStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) {}
    }
    var state = load();

    /* ---------- calculations ---------- */
 function calc() {
  var sub = 0, old = 0, count = 0;
  state.forEach(function (i) {
    sub += i.price * i.qty;
    old += Math.max(i.compare || 0, i.price) * i.qty;
    count += i.qty;
  });
  var unlocked = !!free && sub >= cfg.threshold;
  var saved = old - sub;                    // items ka discount
  if (unlocked) saved += cfg.giftValue;     // + 769 gift
  return { sub: sub, old: old, count: count, unlocked: unlocked, saved: saved };
}

    /* ---------- confetti ---------- */
    function confetti() {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var dpr = window.devicePixelRatio || 1, W = window.innerWidth, H = window.innerHeight;
      var cv = document.createElement('canvas');
      cv.style.cssText = 'position:fixed;left:0;top:0;width:100vw;height:100vh;pointer-events:none;z-index:2147483600';
      cv.width = W * dpr; cv.height = H * dpr;
      document.body.appendChild(cv);
      var ctx = cv.getContext('2d');
      ctx.scale(dpr, dpr);
      var colors = ['#f94144', '#f3722c', '#f9c74f', '#90be6d', '#43aa8b', '#4d96ff', '#9b5de5', '#ff77c8', '#ffd166'];
      var DURATION = 4800, parts = [];
      function make(x, y, vx, vy) {
        return {
          x: x, y: y, vx: vx, vy: vy,
          w: 6 + Math.random() * 7, h: 4 + Math.random() * 6,
          rot: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.35,
          wob: Math.random() * 6.28, wobSpeed: 0.05 + Math.random() * 0.1,
          shape: (Math.random() * 3) | 0,
          color: colors[(Math.random() * colors.length) | 0]
        };
      }
      function burst(x, y, angle, spread, n, power) {
        for (var i = 0; i < n; i++) {
          var a = angle + (Math.random() - 0.5) * spread;
          var sp = power * (0.45 + Math.random() * 0.75);
          parts.push(make(x, y, Math.cos(a) * sp, Math.sin(a) * sp));
        }
      }
      var P = Math.max(12, Math.min(22, H / 38));
      // neeche se teen burst + side se do burst (poori screen cover)
      burst(W * 0.05, H + 10, -Math.PI / 3.2, 1.0, 90, P * 1.15);
      burst(W * 0.95, H + 10, -Math.PI + Math.PI / 3.2, 1.0, 90, P * 1.15);
      burst(W * 0.5, H + 10, -Math.PI / 2, 1.5, 110, P * 1.2);
      burst(-10, H * 0.45, -Math.PI / 5, 0.9, 60, P * 0.95);
      burst(W + 10, H * 0.45, -Math.PI + Math.PI / 5, 0.9, 60, P * 0.95);
      var start = null, spawned = 0, RAIN_FOR = 1800;
      function frame(t) {
        if (start === null) start = t;
        var el = t - start;
        // upar se bhi confetti barish
        if (el < RAIN_FOR) {
          var add = Math.max(2, Math.round(W / 220));
          for (var k = 0; k < add; k++) {
            parts.push(make(Math.random() * W, -12, (Math.random() - 0.5) * 2.5, 2 + Math.random() * 3));
          }
        }
        ctx.clearRect(0, 0, W, H);
        var fade = Math.max(0, Math.min(1, (DURATION - el) / 1200));
        for (var i = parts.length - 1; i >= 0; i--) {
          var q = parts[i];
          q.vy += 0.26; q.vx *= 0.985; q.vy *= 0.985;
          if (q.vy > 7) q.vy = 7;
          q.wob += q.wobSpeed;
          q.x += q.vx + Math.sin(q.wob) * 0.8; q.y += q.vy; q.rot += q.vr;
          if (q.y > H + 30 && el > 600) { parts.splice(i, 1); continue; }
          ctx.save();
          ctx.globalAlpha = fade;
          ctx.translate(q.x, q.y); ctx.rotate(q.rot);
          ctx.fillStyle = q.color;
          if (q.shape === 0) { ctx.fillRect(-q.w / 2, -q.h / 2, q.w, q.h); }
          else if (q.shape === 1) { ctx.beginPath(); ctx.arc(0, 0, q.h / 1.6, 0, 6.2832); ctx.fill(); }
          else { ctx.fillRect(-q.w / 2, -1.5, q.w * 1.3, 3); }
          ctx.restore();
        }
        if (el < DURATION && parts.length) requestAnimationFrame(frame);
        else cv.remove();
      }
      requestAnimationFrame(frame);
    }

    /* ---------- sticky bar (mobile) ---------- */
    function setBarH() {
      var bar = root.querySelector('.gb-bar');
      if (bar) root.style.setProperty('--gb-bar-h', bar.offsetHeight + 'px');
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        root.classList.toggle('is-in-view', en[0].isIntersecting);
      }).observe(root);
    } else {
      root.classList.add('is-in-view');
    }
    window.addEventListener('resize', setBarH);
    if (window.matchMedia) {
      var mqWatch = window.matchMedia('(max-width: 749px)');
      var onMq = function () { render(); };
      if (mqWatch.addEventListener) mqWatch.addEventListener('change', onMq);
      else if (mqWatch.addListener) mqWatch.addListener(onMq);
    }

    /* ---------- render ---------- */
    var LOCK = '<svg class="gb-lock" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';

    function freeBox(c) {
      if (!free) return '';
      var label = c.unlocked ? 'FREE' : 'Unlock at ' + fmt(cfg.threshold);
      return '<div class="gb-box gb-box--free ' + (c.unlocked ? 'is-unlocked' : 'is-locked') + '">' +
        (free.image ? '<img src="' + esc(free.image) + '" alt="' + esc(free.title) + '">' : '') +
        (c.unlocked ? '' : LOCK) +
        '<span class="gb-box__label">' + esc(label) + '</span></div>';
    }
    function itemBox(i) {
      var multi = i.qty > 1;
      return '<div class="gb-box gb-box--filled' + (multi ? ' gb-box--multi' : '') + (i.vid === lastAdded ? ' is-new' : '') + '"' +
        (multi ? ' data-open-modal aria-label="Edit quantity"' : '') + '>' +
        (i.image ? '<img src="' + esc(i.image) + '" alt="' + esc(i.title) + '">' : '') +
        (i.qty > 1 ? '<span class="gb-qty">\u00D7' + i.qty + '</span>' : '') +
        '<button type="button" class="gb-remove" data-remove="' + i.vid + '" aria-label="Remove ' + esc(i.title) + '">\u00D7</button></div>';
    }

    var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
    function renderBoxes(c) {
      var html = freeBox(c);
      var isMobile = !!(mq && mq.matches);
      var LIMIT = isMobile ? 3 : 4;          // itne items tak sab dikhte hain
      var SHOW = isMobile ? 3 : 3;           // limit cross hone par itne box + count box
      if (state.length <= LIMIT) {
        state.forEach(function (i) { html += itemBox(i); });
        // khali "+" box sirf tab jab kuch add na ho; uske baad boxes sirf add hone par badhte hain
        if (state.length === 0) {
          html += '<button type="button" class="gb-box gb-box--empty" data-scroll aria-label="Add a product">+</button>';
        }
      } else {
        state.slice(0, SHOW).forEach(function (i) { html += itemBox(i); });
        html += '<button type="button" class="gb-box gb-box--more" data-open-modal aria-label="View all added products">+' + (state.length - SHOW) + '</button>';
      }
      boxesEl.innerHTML = html;
      if (lastAdded) {
        requestAnimationFrame(function () {
          try { boxesEl.scrollTo({ left: boxesEl.scrollWidth, behavior: 'smooth' }); }
          catch (e) { boxesEl.scrollLeft = boxesEl.scrollWidth; }
        });
      }
    }

    function renderModal(c) {
      modalTitle.textContent = cfg.popupTitle + ' (' + c.count + ')';
      if (!state.length) {
        modalList.innerHTML = '<li class="gb-modal__empty">' + esc(cfg.emptyText) + '</li>';
        return;
      }
      var html = state.map(function (i) {
        return '<li class="gb-row">' +
          (i.image ? '<img src="' + esc(i.image) + '" alt="">' : '<span></span>') +
          '<div class="gb-row__info"><p class="gb-row__title">' + esc(i.title) + '</p>' +
          (i.vtitle ? '<p class="gb-row__variant">' + esc(i.vtitle) + '</p>' : '') +
          '<p class="gb-row__price">' + fmt(i.price * i.qty) + '</p></div>' +
          '<div class="gb-qtyctl"><button type="button" data-dec="' + i.vid + '" aria-label="Decrease">\u2212</button><span>' + i.qty + '</span><button type="button" data-inc="' + i.vid + '" aria-label="Increase">+</button></div>' +
          '<button type="button" class="gb-row__remove" data-remove="' + i.vid + '" aria-label="Remove">\u2715</button></li>';
      }).join('');
      if (free) {
        html += '<li class="gb-row' + (c.unlocked ? '' : ' gb-row--locked') + '">' +
          (free.image ? '<img src="' + esc(free.image) + '" alt="">' : '<span></span>') +
          '<div class="gb-row__info"><p class="gb-row__title">' + esc(free.title) + '</p>' +
          '<p class="gb-row__price">' + (c.unlocked
            ? '<span class="is-free">FREE</span>'
            : 'Add ' + fmt(Math.max(cfg.threshold - c.sub, 0)) + ' more to unlock') + '</p></div></li>';
      }
      modalList.innerHTML = html;
    }

    function render() {
      var c = calc();
var left = fmt(Math.max(cfg.threshold - c.sub, 0));
if (c.unlocked) {
  headingEl.textContent = 'Diwali gift unlocked! You\u2019ve saved ' + fmt(c.saved);
} else if (c.count >= 2) {
  headingEl.textContent = cfg.headingProgress.replace('[amount]', left);
} else {
  headingEl.textContent = cfg.headingLocked.replace('[amount]', left);
}
      renderBoxes(c);
      renderModal(c);
      qa('[data-total]').forEach(function (el) { el.textContent = fmt(c.sub); });
     qa('[data-total-old]').forEach(function (el) {
  var oldShow = c.sub + c.saved;
  var show = c.saved > 0;
  el.hidden = !show;
  if (show) el.textContent = fmt(oldShow);
});
      qa('[data-checkout]').forEach(function (b) { b.disabled = busy; });
      lastAdded = null;
      if (prevUnlocked === false && c.unlocked) confetti();
      prevUnlocked = c.unlocked;
      setBarH();
    }

    /* ---------- state changes ---------- */
    function addItem(item) {
      var found = state.filter(function (i) { return i.vid === item.vid; })[0];
      if (found) { found.qty = Math.min(found.qty + 1, 99); }
      else { item.qty = 1; state.push(item); }
      lastAdded = item.vid;
      save(); render();
    }
    function changeQty(vid, delta) {
      var it = state.filter(function (i) { return i.vid === vid; })[0];
      if (!it) return;
      it.qty += delta;
      if (it.qty <= 0) state = state.filter(function (i) { return i.vid !== vid; });
      save(); render();
    }
    function removeItem(vid) {
      state = state.filter(function (i) { return i.vid !== vid; });
      save(); render();
    }

    /* ---------- cards ---------- */
    function cardData(card) {
      if (!card.__p) {
        try { card.__p = JSON.parse(card.querySelector('[data-product-json]').textContent); }
        catch (e) { card.__p = { variants: [] }; }
      }
      return card.__p;
    }
    function currentVariant(card) {
      var vid = Number(card.dataset.variantId);
      return cardData(card).variants.filter(function (v) { return v.id === vid; })[0];
    }
    function updateCard(card) {
      var p = cardData(card), v = currentVariant(card);
      if (!v) return;
      card.querySelector('[data-price]').textContent = fmt(v.price);
      var cmp = card.querySelector('[data-compare]');
      cmp.hidden = !(v.compare > v.price);
      if (!cmp.hidden) cmp.textContent = fmt(v.compare);
      var img = card.querySelector('[data-card-img]');
      var src = v.image || p.image;
      if (img && src) { img.src = src; img.srcset = ''; img.hidden = false; }
      var btn = card.querySelector('[data-add]');
      btn.disabled = !v.available;
      btn.textContent = v.available ? cfg.addLabel : 'Sold out';
      card.querySelectorAll('[data-pill]').forEach(function (pill) {
        pill.classList.toggle('is-active', Number(pill.dataset.variantId) === v.id);
      });
    }

    /* ---------- modal ---------- */
    function openModal() {
      modal.hidden = false;
      document.body.classList.add('gb-lock');
      var closeBtn = modal.querySelector('.gb-modal__close');
      if (closeBtn) closeBtn.focus();
    }
    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('gb-lock');
    }

    /* ---------- checkout ---------- */
    function checkout(event) {
      if (busy) return;
      if (!state.length) {
        if (gridEl) gridEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      busy = true;
      qa('[data-checkout]').forEach(function (b) { b.disabled = true; b.textContent = 'Please wait\u2026'; });
      var c = calc();
      var base = cfg.root.replace(/\/$/, '');

      // asli items (jo user ne add kiye)
      var baseItems = state.map(function (i) { return { id: i.vid, quantity: i.qty }; });

      // offer variant ke saath uski freebie variant bhi checkout me bhejo
      var items = baseItems.map(function (x) { return { id: x.id, quantity: x.quantity }; });
            // har freebie variant sirf 1 baar (qty = 1), chahe offer variant ki qty kitni bhi ho
      var freeQty = {};
      state.forEach(function (i) {
        var fid = freebieMap[String(i.vid)];
        if (fid) freeQty[fid] = 1;
      });
      var hasFreebie = false;
      Object.keys(freeQty).forEach(function (fid) {
        var existing = items.filter(function (x) { return String(x.id) === fid; })[0];
        if (existing) {
          // user ne khud ye variant add kiya ho to uski qty ke upar sirf +1 freebie
          existing.quantity += 1;
        } else {
          items.push({ id: Number(fid), quantity: 1 });
        }
        hasFreebie = true;
      });

      function addToCart(list) {
        return fetch(base + '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: list })
        });
      }

      // threshold wala free gift sirf front pe dikhta hai, checkout/cart me uski variant id NAHI bheji jaati
      var chain = cfg.clearCart
        ? fetch(base + '/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
        : Promise.resolve();
      chain.then(function () {
        return addToCart(items).then(function (res) {
          // freebie out of stock/fail ho to bina freebie ke dobara try karo
          if (res.ok || !hasFreebie) return res;
          return addToCart(baseItems);
        });
      }).then(function (res) {
        if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
        // items cart me chale gaye: bundle khali, button normal, popup band
        try { localStorage.removeItem(STORE_KEY); } catch (err) {}
        state = [];
        busy = false;
        lastAdded = null;
        closeModal();
        resetCheckoutBtns();
        render();
        typeof handleFloCheckoutBtn === 'function'
          ? handleFloCheckoutBtn(event, undefined, undefined, { isFromCustomSSO: true })
          : (window.location.href = base + '/checkout');
      }).catch(function (err) {
        alert(err.message || 'Something went wrong. Please try again.');
        busy = false;
        resetCheckoutBtns();
        render();
      });
    }

    /* ---------- events ---------- */
    function onClick(e) {
      var t = e.target.closest('[data-add],[data-pill],[data-remove],[data-inc],[data-dec],[data-open-modal],[data-close-modal],[data-checkout],[data-scroll]');
      if (!t || !(root.contains(t) || modal.contains(t))) return;

      if (t.hasAttribute('data-pill')) {
        var pc = t.closest('[data-card]');
        pc.dataset.variantId = t.dataset.variantId;
        updateCard(pc);
      } else if (t.hasAttribute('data-add')) {
        var card = t.closest('[data-card]');
        var p = cardData(card), v = currentVariant(card);
        if (!v || !v.available) return;
        addItem({
          vid: v.id,
          pid: p.id,
          title: p.title,
          vtitle: (v.title && v.title !== 'Default Title') ? v.title : '',
          price: v.price,
          compare: v.compare || 0,
          image: v.image || p.image || '',
          url: p.url
        });
        var old = t.textContent;
        t.textContent = 'Added \u2713';
        setTimeout(function () { t.textContent = cfg.addLabel; }, 900);
      } else if (t.hasAttribute('data-remove')) {
        removeItem(Number(t.dataset.remove));
      } else if (t.hasAttribute('data-inc')) {
        changeQty(Number(t.dataset.inc), 1);
      } else if (t.hasAttribute('data-dec')) {
        changeQty(Number(t.dataset.dec), -1);
      } else if (t.hasAttribute('data-open-modal')) {
        openModal();
      } else if (t.hasAttribute('data-close-modal')) {
        closeModal();
      } else if (t.hasAttribute('data-checkout')) {
        checkout(e);
      } else if (t.hasAttribute('data-scroll')) {
        if (gridEl) gridEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    root.addEventListener('click', onClick);
    modal.addEventListener('click', onClick);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
    window.addEventListener('storage', function (e) {
      if (e.key === STORE_KEY) { state = load(); render(); }
    });
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target && e.target.contains(root)) {
        modal.remove();
        document.body.classList.remove('gb-lock');
      }
    });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { busy = false; state = load(); render(); }
    });

    render();
  }

  function boot() {
    document.querySelectorAll('[data-gb-bundle]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector && e.target.querySelector('[data-gb-bundle]');
    if (el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metadvance-weight-meter"] && !Shopify.designMode) return;
  try {
    
let accumulatedRotation = 360;
document.getElementById("weight-input").addEventListener("keydown", function(event) {
  if (event.key === '-' || event.key === 'e' || event.key === 'E') {
    event.preventDefault();  
  }
});
document.getElementById("weight-input").addEventListener("input", debounce(function () {
     this.value = this.value.replace(/[^0-9.]/g, '');
    if (this.value === '') {
        resetValues();
    return;
  }
 if (this.value > 150) {
    this.value = 150;
  } else if (this.value < 0) {
    this.value = 0;
  }
   const inputWeight = Math.min(parseFloat(this.value) || 0, 150);
  const output = document.getElementById("output");
  const needle = document.getElementById("needle");
  const valueDisplay = document.getElementById("input-value-display");
  const label = document.querySelector(".placeholder-label");

  if (this.value) {
    label.style.display = "none";
    valueDisplay.style.visibility = "visible";
  } else {
    label.style.display = "block";
    valueDisplay.style.visibility = "hidden";
  }

  const weightChange = inputWeight * 0.12;
  const rotationAngle = weightChange * 21; 
  const outwardDuration = 3000; 
  let newRotation = accumulatedRotation + rotationAngle;
  newRotation = Math.ceil(newRotation / 360) * 360;

  needle.style.transition = `transform ${outwardDuration}ms ease-in-out`;
  needle.style.transform = `rotate(${newRotation}deg)`;
  accumulatedRotation = newRotation;

  let currentValue = 0;
  const targetValue = Math.round(weightChange);
  const interval = Math.max(50, outwardDuration / Math.max(targetValue, 1)); 

  function countUp() {
    if (currentValue <= targetValue) {
      if (currentValue === 0) {
        output.textContent = `${currentValue} Kg`;
      }
      else {
        output.textContent = `-${currentValue} Kg`;
      }   
      const remainingWeight = inputWeight - currentValue;
      valueDisplay.textContent = `${Math.round(remainingWeight)} Kg`;
      currentValue++;
      setTimeout(countUp, interval);
    }
  }

  countUp();
}, 300));
  document.getElementById("weight-input").addEventListener("blur", function () {
  if (this.value === '') {
    resetValues();
  }
});

function resetValues() {
  const output = document.getElementById("output");
  const valueDisplay = document.getElementById("input-value-display");
  const label = document.querySelector(".placeholder-label");
  const needle = document.getElementById("needle");

  label.style.display = "block";
  valueDisplay.style.visibility = "hidden";
  output.textContent = '0 Kg';
  valueDisplay.textContent = '0 Kg';
  needle.style.transition = 'none';
  needle.style.transform = `rotate(${accumulatedRotation}deg)`;
}

function debounce(func, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}

  } catch(e) { console.error(e); }
})();
})();
